<template>
  <span>
    <v-dialog v-model="dialog" width="600">
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>{{activatorIcon ? activatorIcon:'mdi-cloud-upload-outline'}}</v-icon>
        </v-btn>
      </template>

      <v-card width="100%" class="mx-auto">
        <v-card-title>
          <span v-if="target=='course'">Upload materials to {{course.name}}</span>
          <v-spacer/>
            <v-btn @click="dialog = false" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
          <v-file-input
            v-model="files"
            placeholder="Upload your documents"
            label="File upload"
            prepend-icon="mdi-paperclip"
            multiple
          />
          <v-chip class="my-2" v-for="file in files" :key="file.name" close @click:close="removeFile(file)">
            {{file.name}}
          </v-chip>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="uploadFiles">
            Upload
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    activatorIcon: {
      type: String,
      required: false,
    },
    target: {
      type: String,
      required: true,
    },
    course: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      files: [],
    };
  },
  watch: {
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  methods: {
    ...mapActions(["addErrorMessage", "addSuccessMessage"]),
    uploadFiles(){
      let formData = new FormData();
      this.files.forEach( f => {
        formData.append('file', f)
      })

      this.$axios.post('/material/upload', formData,
        {
          headers: {
              'Content-Type': 'multipart/form-data'
          },
          params: {
            course_id: this.course.id
          }
        })
        .then( resp => {
          const materials = resp.data.data;
          this.$emit('uploaded', materials);
          this.dialog = false;
        })
        .catch( error => {
          this.addErrorMessage(error.message);
        })
    },
    removeFile(file){
      this.files.splice(this.files.findIndex(f => f.name == file.name), 1);
    }
  },
  mounted() {
    
  },
};
</script>

<style>
</style>